if (!customElements.get('product-media-gallery')) {
  class ProductMediaGallery extends HTMLElement {
    constructor() {
      super();
      this.swiper = undefined;
      this.gap = parseInt(this.getAttribute('data-gap') || 10);
      this.focusAt = this.getAttribute('data-focus-at');
      this.autoplay = this.getAttribute('data-autoplay') === 'true';
      this.hoverpause = this.getAttribute('data-hoverpause') === 'true';
      this.loop = this.getAttribute('data-loop') === 'true';
      this.animationDuration = parseInt(this.getAttribute('data-animation-duration'));
    }

    connectedCallback() {
      const container = this.querySelector('.swiper');
      const prev = this.querySelector('.swiper-button-prev');
      const next = this.querySelector('.swiper-button-next');
      this.swiper = new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: this.gap,
        speed: this.animationDuration,
        centeredSlides: this.focusAt === 'center',
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous',
          nextSlideMessage: 'Next',
          firstSlideMessage: 'First',
          lastSlideMessage: 'Last',
          slideRole: 'listitem',
        },
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
        on: {
          touchStart() {
            container.classList.add('swiper-dragging');
          },
          touchEnd() {
            container.classList.remove('swiper-dragging');
          },
          breakpoint(swiper) {
            if (swiper.allowTouchMove) {
              container.classList.add('swiper-draggable');
            } else {
              container.classList.remove('swiper-draggable');
            }
          },
        },
      });
    }
  }

  customElements.define('product-media-gallery', ProductMediaGallery);
}
